export default function retry(count: number, timeout: number, cb: () => void) {
    let innerCount = count;

    return new Promise((resolve) => {
        const int = setInterval(() => {
            try {
                if (innerCount === 0) {
                    clearInterval(int);
                    resolve();
                    return;
                }

                innerCount--;

                cb();
            } catch (error) {
                clearInterval(int);
            }
        }, timeout);
    });
}
